import {createFileRoute, redirect} from "@tanstack/react-router";
import {isAuthenticated} from "../../utils/auth.ts";
import Layout from "../../components/Layouts/Layout.tsx";
import AccountSettingsContent from "../../components/Settings/AccountSettingsContent.tsx";

export const Route = createFileRoute('/settings/account')({
  beforeLoad: async () => {
    if (!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <AccountSettingsContent />
    </Layout>
  );
}
